import { operate } from '../util/lift';
import { mergeInternals } from './mergeInternals';
export function mergeMap(project, concurrent) {
    if (concurrent === void 0) { concurrent = Infinity; }
    return operate(function (source, subscriber) { return mergeInternals(source, subscriber, project, concurrent); });
}
//# sourceMappingURL=mergeMap.js.map